// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19QN3","col":"styles_col__2JoZf"};